import { 
  RATE_CONFIG_DATA,
  SET_RATES_CONFIG_STEPS,
  SET_EXISTING_RATES_CONFIG_STEPS,
  SET_RATESHEET_CONFIG_VARIABLES,
  SET_WINDOW_FIELDS_DATA,
  SET_RATES_CONFIG_STEPS_COPY
  } from "../actionTypes/RateConfigActionTypes";

export const setRatesConfigData = (payload={},existState={}) => {
    const data = (payload) ? payload :{};
    return { 
      type: RATE_CONFIG_DATA, 
      payload: data ,
      existState: existState
    };
};


export const setConfigRatesStepsAction = (payload) => {
  return { 
    type: SET_RATES_CONFIG_STEPS, 
    payload: payload ,
  };
};

export const setConfigRatesStepsActionCopy = (payload) => {
  return { 
    type: SET_RATES_CONFIG_STEPS_COPY, 
    payload: payload ,
  };
};

export const setExistingConfigRatesStepsAction = (payload) => {
  return { 
    type: SET_EXISTING_RATES_CONFIG_STEPS, 
    payload: payload ,
  };
};

export const setRateSheetAndConfigVariablesAction = (payload)=>{
  return{
    type:SET_RATESHEET_CONFIG_VARIABLES,
    payload:payload
  }
}


export const setWindowFieldsDataAction = (winId,value)=>{
  return{
    type:SET_WINDOW_FIELDS_DATA,
    payload:{
      winId:winId,
      value:value
    }
  }
}


